import { useTranslation } from 'react-i18next'
import { Text } from '@chakra-ui/react'
import { OrderItem } from '@leid/api-orders'

import { getOrderItemDescriptionText } from 'utils/priceDescription'
import { removeDecimals } from 'utils/removeDecimals'
import { JSX } from 'react'

type Props = {
  orderItem: OrderItem
}

const OrderItemPrice = ({ orderItem }: Props): JSX.Element => {
  const { t } = useTranslation(['common', 'statuses'])

  const { refund, price, rebateAmount, deposit } = orderItem

  const getTotalPrice = () => {
    const total = price + (deposit ?? 0)
    return total
  }

  if (refund) {
    return (
      <Text fontSize="smd" fontWeight={300} lineHeight="18px" textAlign="center">
        {t('common:totalPrice')}:{removeDecimals(getTotalPrice() - refund)} {t('common:nok')}
        {' ('}
        <Text as="span" textDecoration="line-through">
          {removeDecimals(price)} {t('common:nok')}
        </Text>
        {')'}
      </Text>
    )
  }

  return (
    <Text fontSize="smd" fontWeight={300} lineHeight="18px" textAlign="center">
      {t('common:totalPrice')}
      {': '}
      {removeDecimals(getTotalPrice())} {t('nok')}
      {deposit !== undefined && deposit > 0 && (
        <Text fontSize="xs" fontWeight={300}>
          {t('common:deposit')}: {removeDecimals(deposit)} {t('nok')} ({t('included')})
        </Text>
      )}
      {rebateAmount !== undefined && (
        <Text fontSize="xs">
          {getOrderItemDescriptionText(
            orderItem.rebateAmount,
            orderItem.rebateCause,
            orderItem.rawPrice,
            orderItem.personalDiscount,
            t,
          )}
        </Text>
      )}
    </Text>
  )
}

export default OrderItemPrice
